import r from "./index944.js";
var o = (function() {
  try {
    var e = r(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})();
export {
  o as default
};
